import { useState } from "react";
import { flashFeed } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const extra = [
  { time: "07:56", tag: "新爆料", title: "一份修订版演出通知被晒出，新增备注栏内有一行小字", read: "0.6万" },
  { time: "07:48", tag: "独家", title: "同剧组化妆间外的闲聊被拾音，提到一个新加的客串人选", read: "1.9万" },
  { time: "07:39", tag: "实锤", title: "公开航班信息显示原定行程被临时改签，目的地成谜", read: "3.1万" },
  { time: "07:27", tag: "现场", title: "发布会前一小时布景仍在上人，工牌颜色被指出两种版本", read: "0.8万" },
  { time: "07:16", tag: "深挖", title: "早年访谈被重新剪辑上传，一句旧话与今天的事件对上了", read: "2.3万" },
  { time: "07:03", tag: "视频", title: "停车场出口拍到未挂牌保姆车，跟车镜头一路追到巷尾", read: "4.7万" },
];

export default function FlashList() {
  const [count, setCount] = useState(flashFeed.length);
  const [follows, setFollows] = useState<Record<number, boolean>>({});

  const list = [...flashFeed, ...extra].slice(0, count);

  return (
    <div>
      <SectionHeading
        index="01"
        title="实时跟进"
        note="按最新时间倒序 · 分钟级更新"
        onMore={() => {}}
      />
      <ul className="mt-2 divide-y divide-background-200">
        {list.map((item, i) => {
          const followed = !!follows[i];
          return (
            <li key={i} className="group flex items-center gap-3 py-3.5 md:gap-4">
              <span className="w-12 shrink-0 font-display text-lg text-foreground-300 transition-colors group-hover:text-primary-600">
                {item.time}
              </span>
              <span
                className={`shrink-0 whitespace-nowrap rounded-sm px-1.5 py-0.5 text-[11px] font-medium ${
                  item.tag === "独家"
                    ? "bg-accent-100 text-accent-900"
                    : item.tag === "实锤" || item.tag === "视频"
                      ? "bg-primary-100 text-primary-800"
                      : "bg-secondary-100 text-secondary-900"
                }`}
              >
                {item.tag}
              </span>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="flex-1 cursor-pointer text-[15px] leading-snug text-foreground-800 transition-colors hover:text-primary-600"
              >
                {item.title}
              </a>
              <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-400 md:flex">
                <i className="ri-eye-line" />
                {item.read}
              </span>
              <button
                type="button"
                onClick={() => setFollows((f) => ({ ...f, [i]: !f[i] }))}
                className={`flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full border text-sm transition-colors ${
                  followed
                    ? "border-primary-300 bg-primary-100 text-primary-700"
                    : "border-background-300 text-foreground-400 hover:border-primary-300 hover:text-primary-600"
                }`}
                aria-label="追踪"
              >
                <i className={followed ? "ri-notification-fill" : "ri-notification-3-line"} />
              </button>
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        onClick={() => setCount((c) => (c >= list.length ? list.length : c + 4))}
        className="mt-4 flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 py-2.5 text-sm text-foreground-500 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        <i className="ri-loader-4-line" />
        加载更多实时动态
      </button>
    </div>
  );
}